/* 🤖 this file was generated by svg-to-ts */
export const siriusPencil: {
  name: 'pencil';
  data: string;
} = {
  name: 'pencil',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.69 3a1.5 1.5 0 0 1 2.12 0L21 7.19a1.5 1.5 0 0 1 0 2.12l-2.462 2.463-.008.007-.008.008-8.772 8.773A1.5 1.5 0 0 1 8.69 21H4.5A1.5 1.5 0 0 1 3 19.5v-4.19a1.5 1.5 0 0 1 .44-1.06L14.69 3Zm5.25 5.25L18 10.19 13.81 6l1.94-1.94 4.19 4.19ZM4.81 15l7.94-7.94 4.19 4.19L9 19.19 4.81 15Zm-.31 1.81v2.69h2.69L4.5 16.81Z" fill="currentColor"/></svg>`
};
